

import { Padding } from '@mui/icons-material';
import React, { useState, useEffect, useRef } from "react";
import Cheforder from '../Ordermanagment/Food/Cheforder';
import axios from 'axios';
import MobileCheforders from '../Ordermanagment/Food/MobileCheforders';
import { Link } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader"; // ✅ Make sure you install react-spinners

const Foodchefmanagment = () => {
    const [orders, setOrders] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(false); // ✅ spinner state
    const [showDetails, setShowDetails] = useState({});
    const isMobile = window.innerWidth <= 768;
    const screenWidth = window.innerWidth;
    const containerHeight = window.innerWidth < 768
        ? '300px'       // Mobile
        : window.innerWidth < 850
            ? '300px'     // Below 850px
            : window.innerWidth < 1400
                ? '410px'   // Between 850px and 1399px
                : window.innerWidth < 1600
                    ? '500px' // Between 1400px and 1599px
                    : '640px'; // Above 1600px

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            const employeeRole = localStorage.getItem("employeRole");
            const role = localStorage.getItem("role");

            if (!token) return;

            try {
                // 1️⃣ Fetch BEING_PREPARED orders using status-range API
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/status-range`,
                    {
                        params: {
                            vendorId: vendorId,
                            fromStatus: "BEING_PREPARED",
                            toStatus: "BEING_PREPARED"
                        },
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                let processingOrders = response.data || [];

                // 2️⃣ Fetch TABLE_DINE_IN orders with BEING_PREPARED items
                const confirmedRes = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/BEING_PREPARED`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const directDineInOrders = confirmedRes.data || [];

                // 3️⃣ Combine both
                let combinedOrders = [
                    ...processingOrders,
                    ...directDineInOrders,
                ];

                // ✅ SORT ORDERS BY DATE (ASCENDING - oldest first)
                combinedOrders.sort((a, b) => {
                    const dateA = new Date(a.orderDateAndTime || a.createdAt || 0);
                    const dateB = new Date(b.orderDateAndTime || b.createdAt || 0);
                    return dateA - dateB; // Ascending order (oldest first)
                });

                // ✅ Apply role-based filtering (same as before)
                const validChefTypes = ["Chef_North", "Chef_South", "Chef_Continental", "Chef_Chinese"];

                if (role === "ROLE_VENDOR") {
                } else if (employeeRole && validChefTypes.includes(employeeRole)) {
                    combinedOrders = combinedOrders.filter((order) =>
                        (order.cartItems || order.order)?.some(
                            (item) => item.chefType && item.chefType === employeeRole
                        )
                    );
                } else {
                    console.warn("⚠️ No valid employee role found — showing no filtered data.");
                }

                // ✅ Update state
                setOrders(combinedOrders);
            } catch (error) {
                console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
        const intervalId = setInterval(fetchOrders, 10000); // every 10 sec
        return () => clearInterval(intervalId);
    }, [vendorId]);


    const handleItemSelect = (orderId, index) => {
        setSelectedItems((prev) => {
            const existing = prev[orderId] || [];
            const updated = existing.includes(index)
                ? existing.filter((i) => i !== index)
                : [...existing, index];
            return { ...prev, [orderId]: updated };
        });
    };

    const handleSelectAll = (orderId, itemsLength) => {
        setSelectedItems((prev) => {
            const isAllSelected = prev[orderId]?.length === itemsLength;
            const newSelection = isAllSelected ? [] : [...Array(itemsLength).keys()];
            return { ...prev, [orderId]: newSelection };
        });
    };

    const orderStages = ["Preparing", "Prepared"];

    const styles = {
        card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)" },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#555', fontWeight: "bold" },
        pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold" },
        tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
        statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
        arrow: { margin: '0 5px' },
        dropdownBtn: {
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '90px' } : {}), // 👈 conditional style
        },
        itemList: { marginTop: '10px', fontWeight: "bold" },
        itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
    };

    const handlePreparedClick = async (order) => {
        const token = localStorage.getItem("authToken");
        if (!token) { alert("Authorization token missing"); return; }

        try {
            if (order.orderType === "TABLE_DINE_IN") {
                const status = "ORDER_IS_READY";
                const note = "Prepared successfully";
                const updatePromises = order.cartItems.map((item) =>
                    axios.put(
                        `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`,
                        {},
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                );
                await Promise.all(updatePromises);
                setOrders((prev) =>
                    prev.map((o) =>
                        o.cartId === order.cartId
                            ? { ...o, cartItems: o.cartItems.map((item) => ({ ...item, orderStatus: status })) }
                            : o
                    )
                );
            } else {
                await axios.put(
                    `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/ORDER_IS_READY`,
                    { status: "ORDER_IS_READY" },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setOrders((prev) =>
                    prev.map((o) => (o.orderId === order.orderId ? { ...o, status: "ORDER_IS_READY" } : o))
                );
            }
        } catch (error) {
            console.error("❌ Failed to update to ORDER_IS_READY:", error.response?.data || error.message);
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="row">
                <div className="col-lg-2">
                    <MobileCheforders />
                </div>
                <div className="col-lg-7 cartdta-mobilee">
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link to="/fooddashboard" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>Food & Beverages</Link>
                        <span className="separator"> &gt; </span>
                        <Link style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>Chef Managment</Link>
                    </p>

                    <div className="chef-managment" style={{ marginTop: isMobile ? "180px" : "120px" }}>
                        <h2 style={{ marginBottom: '0px', marginTop: '-40px' }} className="text-center">👨‍🍳 Chef Order Queue</h2>
                    </div>

                    {/* ✅ Spinner */}
                    {loading ? (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                            <ClipLoader color="#ff4081" size={60} />
                        </div>
                    ) : (
                        <div style={{
                            overflow: "auto",
                            height: window.innerHeight < 500 ? "40vh" : window.innerHeight < 600 ? "45vh" : window.innerHeight < 700 ? "55vh" : window.innerHeight < 800 ? "72vh" : window.innerHeight < 900 ? "70vh" : containerHeight,
                            scrollbarWidth: "thin"
                        }} >
                            {orders.map((order) => {
                                const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                                const orderId = order.orderId || order.cartId;
                                const selected = selectedItems[orderId] || [];

                                return (
                                    <div key={orderId} style={{
                                        border: '1px solid #ccc',
                                        padding: '16px',
                                        margin: '16px',
                                        marginRight: window.innerWidth < 769 ? "16px" : "0px",
                                        borderRadius: '10px',
                                        background: (() => {
                                            const normalized = (order.orderType || "").trim().toLowerCase();
                                            switch (normalized) {
                                                case "dine_in": return "#1E90FF";
                                                case "takeaway": return "#FF6347";
                                                case "delivery": return "#20B2AA";
                                                case "table_dine_in": return "#2051b2ff";
                                                default: return "#b15cd6";
                                            }
                                        })(),
                                    }}>
                                        {/* Updated Header Section */}
                                        <div style={styles.header}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
                                                justifyContent: 'space-between',
                                                alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
                                                gap: window.innerWidth < 1300 ? '10px' : '0',
                                                width: '100%',
                                                padding: '5px 0',
                                            }}>

                                                {/* First Line: Order ID and Date/Time */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: window.innerWidth <= 500 ? 'start' : 'center',
                                                    width: '100%',
                                                    flexDirection: window.innerWidth <= 500 ? "column" : "row",
                                                    marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
                                                    gap: window.innerWidth <= 370 ? '0px' : '10px',
                                                    padding: window.innerWidth < 1300 ? '0 5px' : '0',
                                                }}>
                                                    <div style={{
                                                        ...styles.orderId,
                                                        margin: 0,
                                                        fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                                        fontWeight: 'bold',
                                                        color: "black",
                                                        whiteSpace: 'nowrap',
                                                        display: "flex",
                                                        justifyContent: "space-between", // This pushes children to opposite ends
                                                        alignItems: "center",
                                                        width: "100%", // Ensure it takes full width
                                                    }}>
                                                        {/* Left side - Order ID */}
                                                        <div style={{
                                                            flex: "0 0 auto", // Don't grow, don't shrink, auto width
                                                        }}>
                                                            ORDER ID : <span style={{
                                                                fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                                                color: "white"
                                                            }}>#{orderId}</span>
                                                        </div>

                                                        {/* Right side - Order Type button */}
                                                        <div style={{
                                                            flex: "0 0 auto", // Don't grow, don't shrink, auto width
                                                            marginLeft: "10px", // Add some spacing from Order ID
                                                        }}>
                                                            <button style={{
                                                                background: '#28a745',
                                                                color: '#fff',
                                                                border: 'none',
                                                                padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                                                                borderRadius: '4px',
                                                                fontWeight: 'bold',
                                                                fontSize: '14px',
                                                                whiteSpace: 'nowrap',
                                                                cursor: 'default',
                                                                display: window.innerWidth <= 450 ? "block" : "none",
                                                            }}>
                                                                {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Date and Time inline */}
                                                    {order.orderDateAndTime && (
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            fontSize: window.innerWidth <= 370 ? '14px' : '16px',
                                                            color: '#000000ff',
                                                            fontWeight: '500',
                                                            whiteSpace: 'nowrap',
                                                        }}>
                                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                                {(() => {
                                                                    const dateObj = new Date(order.orderDateAndTime);
                                                                    const date = dateObj.toLocaleDateString('en-IN', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric',
                                                                    });
                                                                    const time = dateObj.toLocaleTimeString('en-IN', {
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                        hour12: true,
                                                                    });
                                                                    return (
                                                                        <>
                                                                            <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
                                                                            <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
                                                                            <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
                                                                            <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </span>
                                                            <button
                                                                style={{
                                                                    background: 'none',
                                                                    border: '0px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    padding: '6px 12px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '14px',
                                                                    minWidth: '40px',
                                                                    display: window.innerWidth > 1299 ? "none" : "block",
                                                                }}
                                                                onClick={() =>
                                                                    setShowDetails((prev) => ({
                                                                        ...prev,
                                                                        [orderId]: !prev[orderId],
                                                                    }))
                                                                }
                                                            >
                                                                {showDetails[orderId] ? '▲' : '▼'}
                                                            </button>
                                                        </div>

                                                    )}
                                                </div>

                                                {/* Second Line: Order Type, Status, and Dropdown */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
                                                    alignItems: 'center',
                                                    gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
                                                    width: '100%',
                                                    padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
                                                    flexWrap: 'wrap',
                                                }}>
                                                    {/* Order Type */}
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}>
                                                        <button style={{
                                                            background: '#28a745',
                                                            color: '#fff',
                                                            border: 'none',
                                                            padding: '6px 15px',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            cursor: 'default',
                                                            display: window.innerWidth > 450 ? "block" : "none",
                                                        }}>
                                                            {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                                                        </button>
                                                    </div>


                                                    {/* Dropdown button */}
                                                    <button
                                                        style={{
                                                            background: 'none',
                                                            border: '0px solid #ccc',
                                                            borderRadius: '4px',
                                                            padding: '6px 12px',
                                                            cursor: 'pointer',
                                                            fontSize: '14px',
                                                            minWidth: '40px',
                                                            display: window.innerWidth > 1299 ? "block" : "none",
                                                        }}
                                                        onClick={() =>
                                                            setShowDetails((prev) => ({
                                                                ...prev,
                                                                [orderId]: !prev[orderId],
                                                            }))
                                                        }
                                                    >
                                                        {showDetails[orderId] ? '▲' : '▼'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Order Details */}
                                        {showDetails[orderId] && (
                                            <>
                                                <div style={{ marginTop: window.innerWidth < 450 ? '-1rem' : '0rem', margin: window.innerWidth < 768 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 30%" : "0px 15%" }}>
                                                    {/* Table with invisible styling */}
                                                    <table style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                        border: 'none',
                                                        background: 'transparent'
                                                    }}>
                                                        {/* Table Header - invisible */}
                                                        <thead>
                                                            <tr style={{
                                                                border: 'none',
                                                                background: 'transparent'
                                                            }}>
                                                                <th style={{
                                                                    textAlign: 'center',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                                                    padding: '8px 10px',
                                                                    paddingBottom: '0px',
                                                                    border: 'none',
                                                                    background: 'transparent'
                                                                }}>
                                                                    ITEM
                                                                </th>
                                                                <th style={{
                                                                    textAlign: window.innerWidth < 450 ? 'center' : 'center',
                                                                    color: 'black',
                                                                    fontWeight: 'bold',
                                                                    fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                                                    padding: '8px 10px',
                                                                    paddingBottom: '0px',
                                                                    border: 'none',
                                                                    background: 'transparent'
                                                                }}>
                                                                    QUANTITY
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        {/* Table Body - invisible */}
                                                        <tbody>
                                                            {orderItems
                                                                .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                                                                .map((item, index) => (
                                                                    <tr
                                                                        key={index}
                                                                        style={{
                                                                            border: 'none',
                                                                            background: 'transparent'
                                                                        }}
                                                                    >
                                                                        {/* Item column with checkbox */}
                                                                        <td style={{
                                                                            padding: '0px 20px',
                                                                            paddingTop: '0px',
                                                                            border: 'none',
                                                                            background: 'transparent',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '10px'
                                                                        }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={!!selectedItems[item.listId || item.id || index]}
                                                                                onChange={() => {
                                                                                    const id = item.listId || item.id || index;
                                                                                    setSelectedItems(prev => ({
                                                                                        ...prev,
                                                                                        [id]: !prev[id]
                                                                                    }));
                                                                                }}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    marginRight: '20px'
                                                                                }}
                                                                            />
                                                                            <span style={{
                                                                                fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                                                                color: '#ffffffff'
                                                                            }}>
                                                                                {item.dishName}
                                                                            </span>
                                                                        </td>

                                                                        {/* Quantity column */}
                                                                        <td style={{
                                                                            padding: '8px 10px',
                                                                            paddingTop: '0px',
                                                                            border: 'none',
                                                                            background: 'transparent',
                                                                            textAlign: window.innerWidth < 450 ? 'center' : 'center',
                                                                            fontWeight: 'bold',
                                                                            fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                                                            color: '#ffffffff'
                                                                        }}>
                                                                            {item.quantity || 1}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        )}

                                        {/* Order Stages Tracker */}
                                        <div style={{
                                            marginTop: '10px',
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '5px' : '0px',
                                            fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
                                            fontWeight: "bold"
                                        }}>
                                            {Array.isArray(orderStages) &&
                                                orderStages.map((stage, index) => {
                                                    let isActive = false;
                                                    let isClickable = false;

                                                    if (order.orderType !== "TABLE_DINE_IN" &&
                                                        ((order.status === "BEING_PREPARED" && stage === "Preparing") ||
                                                            (order.status === "ORDER_IS_READY" && stage === "Prepared"))
                                                    ) {
                                                        isActive = true;
                                                        isClickable = stage === "Prepared" && order.status === "BEING_PREPARED";
                                                    }

                                                    if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                                                        if (stage === "Preparing" && order.cartItems.some((item) => item.orderStatus === "BEING_PREPARED")) {
                                                            isActive = true;
                                                        }
                                                        if (stage === "Prepared" && order.cartItems.some((item) => item.orderStatus === "ORDER_IS_READY")) {
                                                            isActive = true;
                                                            isClickable = true;
                                                        }
                                                    }

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div
                                                                onClick={() => { if (stage === "Prepared") handlePreparedClick(order); }}
                                                                style={{
                                                                    backgroundColor: isActive ? "green" : "#f0f0f0",
                                                                    color: isActive ? "white" : "black",
                                                                    borderRadius: "6px",
                                                                    padding: "8px 12px",
                                                                    fontWeight: "bold",
                                                                    textTransform: "uppercase",
                                                                    cursor: isClickable ? "pointer" : "default",
                                                                    transition: "all 0.3s ease",
                                                                }}
                                                            >
                                                                {stage}
                                                            </div>
                                                            {index !== orderStages.length - 1 && (
                                                                <span style={{ margin: '0 5px' }}></span>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="col-lg-3" style={{ display: window.innerWidth <= 768 ? "none" : "block" }}>
                    <Cheforder />
                </div>
            </div>
        </div>
    );
};

export default Foodchefmanagment;
